export enum MissionAcceptanceType {
  creation = 'creation',
  previousAccountantRecovery = 'previous_accountant_recovery',
  recoveryWithoutAccountant = 'recovery_without_accountant'
}
